import styled, { css } from 'styled-components';
import { OverflowEllipsis } from 'utils/fragments';

const BodyFragment = css`
    font-family: ${({ theme }) => theme.style_primary};
    font-size: 1rem;
`;
const BodySemiFragment = css`
    ${BodyFragment};
    font-weight: ${({ theme }) => theme.fontBold};
`;
export const BodySemi = styled.span`
    ${BodySemiFragment}
`;
BodySemi.Fragment = BodySemiFragment;
const BodyRegularFragment = css`
    ${BodyFragment};
    font-weight: ${({ theme }) => theme.fontMedium};
`;
export const BodyRegular = styled.span`
    ${BodyRegularFragment}
`;
BodyRegular.Fragment = BodyRegularFragment;

const BodyMediumFragment = css`
    ${BodyFragment};
    font-weight: ${({ theme }) => theme.fontSemiBold};
`;
export const BodyMedium = styled.span`
    ${BodyMediumFragment}
`;
BodyMedium.Fragment = BodyMediumFragment;

export const EllipsizedBodyMedium = styled(BodyMedium)`
    ${OverflowEllipsis}
`;

const SmallBodyFragment = css`
    ${BodyFragment};
    font-size: 0.875rem;
`;

const SmallBodyRegularFragment = css`
    ${SmallBodyFragment};
    font-weight: ${({ theme }) => theme.fontMedium};
`;

export const SmallBodyRegular = styled.span`
    ${SmallBodyRegularFragment}
`;
SmallBodyRegular.Fragment = SmallBodyRegularFragment;

const SmallBodyRegularSemiFragment = css`
    ${SmallBodyFragment};
    font-weight: ${({ theme }) => theme.fontBold};
`;

export const SmallBodyRegularSemi = styled.span`
    ${SmallBodyRegularSemiFragment}
`;
SmallBodyRegularSemi.Fragment = SmallBodyRegularSemiFragment;

const CaptionRegularFragment = css`
    font-family: ${({ theme }) => theme.style_primary};
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.fontMedium};
`;

export const CaptionRegular = styled.span`
    ${CaptionRegularFragment}
`;
CaptionRegular.Fragment = CaptionRegularFragment;

const CaptionSemiFragment = css`
    ${CaptionRegularFragment};
    font-weight: ${({ theme }) => theme.fontBold};
`;

export const CaptionSemi = styled.span`
    ${CaptionSemiFragment}
`;
CaptionSemi.Fragment = CaptionSemiFragment;

const CapitalizeFragment = css`
    text-transform: capitalize;
`;
export const Capitalize = styled.span`
    ${CapitalizeFragment}
`;
Capitalize.Fragment = CapitalizeFragment;

const HeadingThreeFragment = css`
    font-family: ${({ theme }) => theme.style_primary};
    font-size: 1.125rem; /* 18px */
    font-weight: ${({ theme }) => theme.fontBold};
    line-height: normal;
`;
export const HeadingThree = styled.span`
    ${HeadingThreeFragment}
`;
HeadingThree.Fragment = HeadingThreeFragment;
